/* eslint-disable */
import { enterInViewport } from '@/utils/Common/Booleans';
import { initCarouselMobileOnly } from '@/braun/Controllers/BraunCarouselController';

export const initStickyMenu = () => {
  const isPresent = document.querySelector('.bra-sticky-navigation');
  if (isPresent) {
    let lastScrollTop = 0;
    const links = document.querySelectorAll(
      'a[href^="#"].bra-sticky-navigation__link',
    );
    const linksArr = [...document.querySelectorAll('.bra-sticky-navigation__link')]
    const removeClassSelectedToLinks = () =>
      [...document.querySelectorAll('.bra-sticky-navigation__link')].map(el =>
        el.classList.remove('selected'),
      );

    Array.from(links).forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const stickyNavigationSwiper = document.querySelector(".bra-sticky-navigation .swiper-container").swiper;
        if(stickyNavigationSwiper && stickyNavigationSwiper.destroyed !== true) {
          let index = linksArr.indexOf(e.currentTarget);
          stickyNavigationSwiper.slideTo(index, 100);
        }
        removeClassSelectedToLinks();
        anchor.classList.add('selected');
        const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);
        e.preventDefault();
        const targetID = this.getAttribute('href');

        e.preventDefault();
        const targetAnchor = document.querySelector(targetID);
        if (!targetAnchor) return;
        const originalTop = distanceToTop(targetAnchor);

        if('scrollBehavior' in document.documentElement.style) {
          window.scrollBy({ top: originalTop - 225, left: 0, behavior: 'smooth' });
        }
        else {
          window.scrollBy(0, originalTop - 225);
        }

        const checkIfDone = setInterval(() => {
          const atBottom =
            window.innerHeight + window.pageYOffset >=
            document.body.offsetHeight;
          if (distanceToTop(targetAnchor) === 0 || atBottom) {
            targetAnchor.tabIndex = '-1';
            targetAnchor.focus();
            clearInterval(checkIfDone);
          }
        }, 100);
      });
    });

    window.addEventListener(
      'scroll',
      event => {
        const navigation = document.querySelector('.bra-sticky-navigation');
        const el = document.getElementById('start-sticky-menu');

        
        const st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          if (enterInViewport(el)) {
            navigation.classList.add('open');
          }
        } else if (!enterInViewport(el)) {
          navigation.classList.remove('open');
        }

        [...links].map(el => {
          const entered = enterInViewport(
            document.querySelector(el.getAttribute('href')),
          );
          if (entered) {
            if (!el.classList.contains('selected')) {
              removeClassSelectedToLinks();
              el.classList.add('selected');
              const stickyNavigationSwiper = document.querySelector(".bra-sticky-navigation .swiper-container").swiper;
              if(stickyNavigationSwiper && stickyNavigationSwiper.destroyed !== true) {
                let index = linksArr.indexOf(el);
                stickyNavigationSwiper.slideTo(index, 200);
              }
            }
          }
        });

        lastScrollTop = st <= 0 ? 0 : st;
      },
      false,
    );
  }
};

export const initStickyMenuSlider = () => {
  const stickyMenuSlider = document.getElementsByClassName(
    'bra-sticky-navigation__slide',
  )[0];

  if (stickyMenuSlider)
    initCarouselMobileOnly(stickyMenuSlider, {
      slidesPerViewXs: 'auto',
      spaceBetweenXs: 0,
    });

  return stickyMenuSlider;
};

export default () => {
  initStickyMenu();
  initStickyMenuSlider();
};
